/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

// This generates a query string on the fly as you cannot parametrize an object
// type inside an inline fragment (... on $objectType isn't valid syntax).
export default (type: string, ids: number[]) => {
  const idsString = JSON.stringify(ids.map(id => `${type}:${id}`));
  const fieldMapping = getFieldMapping(type);
  return `query {
    nodes(ids: ${idsString}){
      ... on ${type} {
        dbId
        identifier: ${fieldMapping.identifier} {
          value
        }
        title: ${fieldMapping.title} {
          value
        }
      }
    }
  }`;
};

export const ObjectsQuery = (type: string) => {
  const fieldMapping = getFieldMapping(type);
  return `query objects {
    search(type: ${type}) {
      edges {
        node {
          id
          ... on ${type} {
            dbId
            identifier: ${fieldMapping.identifier} {
              value
            }
            title: ${fieldMapping.title} {
              value
            }
          }
        }
      }
    }
  }`;
};

export const getFieldMapping = (type: string): { identifier: string; title: string } => {
  if (type === 'Person') {
    return { identifier: 'email', title: 'name' };
  } else {
    return { identifier: 'slug', title: 'title' };
  }
};
